import { projects } from '../data/content';
import type { Project } from '../data/types';
import { ArrowOut, SectionHead, delay } from './primitives';

function Card({ project, index }: { project: Project; index: number }) {
  return (
    <article className="card" data-reveal style={delay((index % 2) * 90)}>
      <div className="card__cap" />

      <p className="card__meta">
        <span>{project.period}</span>
        {project.context && <span>{project.context}</span>}
      </p>

      <h3 className="card__title">{project.title}</h3>
      <p className="card__summary">{project.summary}</p>
      <p className="card__detail">{project.detail}</p>

      <ul className="card__metrics">
        {project.metrics.map((metric) => (
          <li key={metric}>{metric}</li>
        ))}
      </ul>

      <p className="card__stack">
        {project.stack.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </p>

      {project.note && <p className="card__note">{project.note}</p>}

      {project.links.length > 0 && (
        <div className="card__links">
          {project.links.map((link) => (
            <a className="card__link" key={link.href} href={link.href} target="_blank" rel="noreferrer">
              {link.label}
              <ArrowOut />
            </a>
          ))}
        </div>
      )}
    </article>
  );
}

export function Work() {
  return (
    <section className="section section--alt" id="projects" aria-labelledby="projects-title">
      <div className="container">
        <SectionHead title="Projects" id="projects-title" />

        <div className="projects">
          {projects.map((project, i) => (
            <Card key={project.id} project={project} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
